import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Plus, Search, Filter, Briefcase, Clock, CheckCircle,
  MapPin, DollarSign, Star,
  Wrench, UserPlus
} from 'lucide-react';
import axios from "axios";
import AppContext from '../../../../context/AppContext';
import echo from '../../../../config/echo';

import STATES from '../../../../components/admin/dashboard/systemjobs/states/States';
import PostJobModal from '../../../../components/admin/dashboard/systemjobs/systempostjobModal/SystemPostJobModal';

import '../../../../assets/css/screens/admin/dashboard/systemjobs/SystemJobs.css';

// Main Page Component
const SystemJobs = () => {
  const navigate = useNavigate();
  const {baseUrl} = useContext(AppContext);
 
  const [activeState, setActiveState] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [serviceType, setServiceType] = useState('');
    const [jobTitle, setJobTitle] = useState('');
    const [description, setDescription] = useState('');
    const [budget, setBudget] = useState('');
    const [city, setCity] = useState('');

    const [address, setAddress] = useState('');
    const [deadline, setDeadline] = useState('');
    const [fullName,    setFullName]    = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email,       setEmail]       = useState('');
    const [bidding, setBidding] = useState('');
    const [media, setMedia] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectservice, setSelectService] = useState();
    const [open, setOpen] = useState(false);

const [selectedCustomer, setSelectedCustomer] = useState();
const [selectedWorker, setSelectedWorker] = useState();
  const [jobs, setJobs] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [workers, setWorkers] = useState([]);

// post jobs
const handlePostJob = (jobData) => {
  console.log("JOB DATA:", jobData);
  console.log("SELECTED WORKER:", jobData.worker);

  setLoading(true);

  const formData = new FormData();

  formData.append("jobTitle", jobData.jobTitle);
formData.append("whcategory_id", jobData.whcategory_id);
  formData.append("budget", jobData.budget);
  formData.append("address", jobData.address);
  formData.append("deadline", jobData.deadline);
  formData.append("fullName", jobData.fullName);
  formData.append("phoneNumber", jobData.phoneNumber);
  formData.append("email", jobData.email);
  formData.append("description", jobData.description);

  // Customer ID
  if (jobData.customer?.id) {
    formData.append("customer_id", jobData.customer.id);
  }

  // Worker ID
  if (jobData.worker?.id) {
formData.append("whserviceprovider_id", jobData.worker.id);  }

  // Media Files
  if (jobData.mediaFiles?.length > 0) {
    jobData.mediaFiles.forEach((item) => {
      formData.append("media[]", item.file);
    });
  }

  // Debug
  for (let pair of formData.entries()) {
    console.log(pair[0], pair[1]);
  }

  axios
    .post(`${baseUrl}/post/job`, formData, {
      headers: {
        Authorization: `Bearer ${
          localStorage.getItem("authToken") || ""
        }`,
        "Content-Type": "multipart/form-data",
      },
    })
  .then((response) => {
  console.log("POST JOB RESPONSE:", response);
  console.log("POST JOB RESPONSE DATA:", response.data);
  console.log(jobData);
console.log("Category ID:", jobData.whcategory_id);

  setLoading(false);

  if (response.data.success) {
    fetchJobs();
    setShowModal(false);
  } else {
    alert(response.data.error || response.data.message);
  }
})
    .catch((err) => {
      setLoading(false);

      console.log("FULL ERROR RESPONSE:", err.response?.data);
      console.log("STATUS:", err.response?.status);

      // alert(
      //   err.response?.data?.message ||
      //     "Something went wrong while posting job"
      // );
    });
};

// fetch customers
const fetchCustomers = async () => {
  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) return;

    const res = await axios.get(`${baseUrl}/view/customers`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    // 👇 YAHAN lagao
    console.log("FETCH CUSTOMERS CALLED");
    console.log("CUSTOMER API RESPONSE:", res.data);

    const data =
      res.data?.customers ||
      res.data?.data ||
      res.data ||
      [];

    setCustomers(
      data.map(c => ({
        id: c.id,
        fullName: c.fullName || c.name || '',
        email: c.email || '',
        phoneNumber: c.phoneNumber || c.phoneNumber || '',
      }))
      
    );

  } catch (err) {
    console.log('API ERROR:', err.response?.data || err.message);
  }
};

// fetch workers
const fetchWorkers = async () => {
  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) return;

    const res = await axios.get(`${baseUrl}/view/workers`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const data =
      res.data?.workers ||
      res.data?.data ||
      res.data ||
      [];

    console.log("WORKERS FINAL DATA:", data);

    setWorkers(data);

  } catch (err) {
    console.log("WORKERS ERROR:", err.response?.data || err.message);
  }
};

// fetch categories
const fetchCategories = async () => {
  try {
    const authToken = localStorage.getItem('authToken');

    const res = await axios.get(`${baseUrl}/whadmin/viewAllCategory`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

   const data =
  res.data?.category ||   // 👈 yeh add karo
  res.data?.data ||
  res.data ||
  [];

    console.log("CATEGORIES:", data);

    setCategories(data);

  } catch (err) {
    console.log("CATEGORY ERROR:", err.response?.data || err.message);
  }
};

// fetch jobs
const fetchJobs = async () => {
  try {
    const authToken = localStorage.getItem('authToken');

    const res = await axios.get(`${baseUrl}/view/jobs`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    console.log("JOBS RESPONSE:", res.data.jobs);

    setJobs(res.data.jobs || []);
  } catch (err) {
    console.log(err);
  }
};
useEffect(() => {

  const channel = echo.channel('admin-jobs');

  channel.listen('.JobStatusUpdated', (event) => {

    console.log("JOB UPDATED:", event);

    fetchJobs();

  });


  return () => {
    echo.leave('admin-jobs');
  };

}, []);
useEffect(() => {
  const loadData = async () => {
    await Promise.all([
      fetchCategories(),
      fetchCustomers(),
      fetchWorkers(),
      fetchJobs()
    ]);
  };

  loadData();
}, []);

const handleAddCustomer = (customer) => {
  setCustomers(prev => [customer, ...prev]);
};

const filteredJobs = jobs.filter(job => {
  const search = searchQuery.toLowerCase();

  return (
    activeState === 'all' || job.status === activeState
  ) && (
    (job?.jobTitle || '').toLowerCase().includes(search) ||
  (job?.whcategory?.categoryName || '')
  .toLowerCase()
  .includes(search)
  );
});

  const stats = [
    { label: 'Total Jobs', value: jobs.length, icon: <Briefcase size={20} />, color: '#0491e1' },
    { label: 'In Progress', value: jobs.filter(j => j.status === 'in_progress').length, icon: <Clock size={20} />, color: '#f59e0b' },
    { label: 'Completed', value: jobs.filter(j => j.status === 'completed').length, icon: <CheckCircle size={20} />, color: '#10b981' },
  ];

  return (
    <div className="sj-page">
      {/* Header */}
      <div className="sj-header">
        <div className="sj-header__left">
          <Wrench size={24} className="sj-header__icon" />
          <div>
            <h1 className="sj-header__title">Post Jobs</h1>
            <p className="sj-header__subtitle">Post jobs on behalf of customers and assign trusted workers instantly.</p>
          </div>
        </div>
        <div className="sj-header__actions">
          {/* <button className="sj-btn sj-btn--add-customer" onClick={() => setShowAddCustomer(true)}>
            <UserPlus size={18}/> Add Customer
          </button> */}
          <button className="sj-btn sj-btn--post" onClick={() => setShowModal(true)}>
            <Plus size={18} /> Post New Job
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="sj-stats">
        {stats.map((stat, i) => (
          <div key={i} className="sj-stat-card" style={{ '--stat-color': stat.color }}>
            <div className="sj-stat-card__icon">{stat.icon}</div>
            <div className="sj-stat-card__info">
              <div className="sj-stat-card__value">{stat.value}</div>
              <div className="sj-stat-card__label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Search & Filter Bar */}
      <div className="sj-toolbar">
        <div className="sj-search">
          <Search size={16} />
          <input
            type="text"
            placeholder="Search jobs..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="sj-filter-dropdown">
          <Filter size={16} />
          <select value={activeState} onChange={e => setActiveState(e.target.value)}>
            {Object.entries(STATES).map(([key, state]) => (
              <option key={key} value={key}>{state.label}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Jobs List */}
      <div className="sj-jobs-list">

{filteredJobs.length === 0 ? (
  <div className="sj-empty">
    <Briefcase size={48} />
    <p>No jobs found</p>
  </div>
) : (
  filteredJobs.map((job, i) => {

  console.log("JOB:", job); // 👈 YAHAN LAGAO

  const state = STATES[job.status] || STATES.all;

  const customer = job.whcustomer;
  const worker = job.whserviceprovider;

  return (
              <div key={job.id} className="sj-job-card" style={{ animationDelay: `${i * 0.05}s` }}>
                {/* Card Header */}
                <div className="sj-job-card__header">
                  <div className="sj-job-card__header-left">
                    <span className="sj-job-card__id">{job.id}</span>
                    <span className="sj-job-card__badge" style={{ color: state.color, background: state.bg }}>
                      {state.icon} {state.label}
                    </span>
                  </div>
                </div>

                {/* Title & Category */}
                <h3 className="sj-job-card__title">{job.jobTitle}</h3>
                <div className="sj-job-card__category">
<Wrench size={13} />
{job.whcategory?.categoryName || "N/A"}
                </div>

                {/* Description */}
                <p className="sj-job-card__desc">{job.description}</p>

                {/* Meta Info */}
                <div className="sj-job-card__meta">
                  <span><MapPin size={13} /> {job.address}</span>
                  <span><Clock size={13} /> {job.deadline}</span>
                  <span><DollarSign size={13} /> ${job.budget}</span>
                </div>

                {/* Profiles */}
                <div className="sj-job-card__profiles">
                  {/* Customer */}
                <div className="sj-job-profile">
  <span className="sj-job-profile__label">CUSTOMER</span>

  <div className="sj-job-profile__card">
    <div className="sj-job-profile__avatar sj-job-profile__avatar--customer">
      {customer?.fullName
        ?.split(' ')
        ?.map(n => n[0])
        ?.join('') || 'C'}
    </div>

    <div className="sj-job-profile__info">
      <span className="sj-job-profile__name">
        {job.whcustomer?.fullName || 'Unknown Customer'}
      </span>

      <span className="sj-job-profile__detail">
        {job.whcustomer?.phoneNumber || '-'}
      </span>
    </div>
  </div>
</div>

                  {/* Worker */}
                <div className="sj-job-profile">
  <span className="sj-job-profile__label">WORKER</span>

  <div className="sj-job-profile__card">
    <div className="sj-job-profile__avatar sj-job-profile__avatar--worker">
      {worker?.fullName
        ?.split(' ')
        ?.map(n => n[0])
        ?.join('') || 'W'}
    </div>

    <div className="sj-job-profile__info">
      <span className="sj-job-profile__name">
        {job.whserviceprovider?.fullName || 'Unknown Worker'}
      </span>

      <div className="sj-job-profile__stats">
        <span>
          <Star size={10} fill="#f59e0b" color="#f59e0b" />
          {job.whserviceprovider?.rating || 0}
        </span>

        <span>•</span>

        <span>
          {job.whserviceprovider?.jobs || 0} jobs
        </span>
      </div>
    </div>
  </div>
</div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* Post Job Modal */}
      {showModal && (
<PostJobModal
  onClose={() => setShowModal(false)}
  onSubmit={handlePostJob}
  customers={customers}
  workers={workers}
  categories={categories}
  loading={loading}
/>
      )}

     
    </div>
  );
};

export default SystemJobs;